import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { b2cHubspotApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${b2cHubspotApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
